module.exports = __webpack_public_path__ + "img/icone-llb.924c656e.png";